import { getLiteral } from 'utils/getLiteral';

export const NOOP_MARKETING_STATUS_CHANGE = () => {};

export const getMarketingStatusColumn = ({
    hide = false,
    width,
    minWidth,
    onChange = NOOP_MARKETING_STATUS_CHANGE,
} = {}) => ({
    colId: 'marketingStatus',
    headerName: getLiteral('label_marketing_status'),
    field: 'MarketingCommunications',
    sortField: 'marketingStatus',
    fieldConfiguration: 'marketingStatus',
    cellRenderer: 'MarketingStatusCell',
    cellRendererParams: {
        onChange,
    },
    ...(typeof width === 'number' ? { width } : {}),
    ...(typeof minWidth === 'number' ? { minWidth } : {}),
    suppressSizeToFit: true,
    hide,
});
